// extracted by mini-css-extract-plugin
export default {"colors-primary":"#2e54c8","colors-secondary":"#279ddf","colors-accent1":"#6e50bc","colors-accent2":"#1ebb60","colors-white":"#f8f8f8","mainContainer":"app_mainContainer__ZDMvX"};